import Button from "@material-ui/core/Button";
import moment from "moment-timezone";
import React from "react";
import EditFieldDialog from "../../components/schedule/EditFieldDialog";
import { languages } from "../../constants/languages";
import { getUploadErrorMessage } from "../../util/uploadErrors";

class EditFieldContainer extends React.Component {
  state = {
    open: false,
    name: "",
    startTime: "",
    endTime: "",

    showSponsor: false,
    sponsorName: "",
    sponsorLogoURL: "",
    isUploading: false,
    errorMessageSponsor: "",
    newSponsorLogo: false,
  };

  handleShowSponsorChange = (event, checked) => {
    let newState = {};
    newState[event.target.name] = checked;
    this.setState(newState);
  };

  toggleDialog = () => {
    if ((this.props.tournamentStatus || {}).closed) {
      this.props.toggleFinishedDialog();
    } else {
      if (this.state.open && this.props.handleMenuClose) {
        this.props.handleMenuClose();
      }
      this.setState({ open: !this.state.open });
    }
  };

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const field = nextProps.field;
    if (field) {
      let newStartTime = field.startTime;
      let startTime = this.props.field.startTime;
      let newEndTime = field.endTime || "";
      let endTime = this.props.field.endTime || "";
      if (this.props.selectedDay !== "0") {
        newStartTime = field[this.props.selectedDay] || field.startTime;
        startTime =
          this.props.field[this.props.selectedDay] ||
          this.props.field.startTime;
        newEndTime =
          field[this.props.selectedDay + "end"] !== undefined
            ? field[this.props.selectedDay + "end"]
            : field.endTime || "";
        endTime =
          this.props.field[this.props.selectedDay + "end"] !== undefined
            ? this.props.field[this.props.selectedDay + "end"]
            : this.props.field.endTime || "";
      }
      if (
        field.name !== this.props.field.name ||
        newStartTime !== startTime ||
        newEndTime !== endTime
      ) {
        this.updateState(field);
      }
    }
  };

  UNSAFE_componentWillMount = () => {
    if (this.props.lastStartTime) {
      this.setState({
        startTime: moment.unix(this.props.lastStartTime).format("HH:mm"),
      });
    }
    if (this.props.lastEndTime && !this.props.field) {
      this.setState({
        endTime: moment.unix(this.props.lastEndTime).format("HH:mm"),
      });
    }
    if (this.props.field) {
      this.updateState(this.props.field);
    }
  };

  updateState = (field) => {
    let startTime = field.startTime;
    let endTime = field.endTime || "";
    if (this.props.selectedDay !== "0") {
      startTime = field[this.props.selectedDay] || field.startTime;
      endTime =
        field[this.props.selectedDay + "end"] !== undefined
          ? field[this.props.selectedDay + "end"]
          : field.endTime || "";
    }
    this.setState({
      name: field.name || "",
      startTime: startTime ? moment.unix(startTime).format("HH:mm") : "",
      endTime: endTime ? moment.unix(endTime).format("HH:mm") : "",
      showSponsor: field.showSponsor || false,
      sponsorName: field.sponsorName || "",
      sponsorLogoURL: field.sponsorLogoURL || "",
    });
  };

  handleChange = (event) => {
    let newState = {};
    newState[event.target.name] = event.target.value;
    this.setState(newState);
  };

  handleStartTimeChange = (value) => {
    let newState = {};
    newState["startTime"] = value ? value.format("HH:mm") : "";
    this.setState(newState);
  };

  handleEndTimeChange = (value) => {
    let newState = {};
    newState["endTime"] = value ? value.format("HH:mm") : "";
    this.setState(newState);
  };

  handleSubmit = (e) => {
    e.preventDefault();
    if (this.props.field) {
      this.props.toggleDialog();
    } else {
      this.toggleDialog();
    }
    const db = window.firebase.firestore();
    let batch = db.batch();
    const tournamentRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"]);

    const oldStartTime = this.props.field
      ? this.props.selectedDay === "0"
        ? this.props.field.startTime
        : this.props.field[this.props.selectedDay] || this.props.field.startTime
      : null;
    const oldEndTime = this.props.field
      ? this.props.selectedDay === "0"
        ? this.props.field.endTime || ""
        : this.props.field[this.props.selectedDay + "end"] !== undefined
          ? this.props.field[this.props.selectedDay + "end"]
          : this.props.field.endTime || ""
      : null;

    let newField = this.props.field ? this.props.field : {};

    newField["name"] = this.state.name;
    newField["showSponsor"] = this.state.showSponsor;
    newField["sponsorName"] = this.state.sponsorName;
    newField["sponsorLogoURL"] = this.state.sponsorLogoURL;

    newField["sportPark"] = this.props.selectedSportPark;
    newField[
      this.props.selectedDay === "0" ? "startTime" : this.props.selectedDay
    ] = moment(this.state.startTime, "HH:mm").unix();

    if (this.props.selectedDay === "0") {
      newField["startTime"] = moment(this.state.startTime, "HH:mm").unix();
      newField["endTime"] = this.state.endTime
        ? moment(this.state.endTime, "HH:mm").unix()
        : "";
    } else {
      newField[this.props.selectedDay] = moment(
        this.state.startTime,
        "HH:mm",
      ).unix();
      if (newField["startTime"] === undefined) {
        newField["startTime"] = moment(this.state.startTime, "HH:mm").unix();
      }
      newField[this.props.selectedDay + "end"] = this.state.endTime
        ? moment(this.state.endTime, "HH:mm").unix()
        : "";
    }

    let newFields = this.props.tournament.fields || {};

    let fieldId = "";
    if (this.props.field) {
      fieldId = this.props.field.id;
    } else {
      if (window.firebase.analytics) {
        window.firebase.analytics().logEvent("field_added");
      }
      const newFieldKeys = Object.keys(newFields).sort((a, b) => a - b);
      fieldId = Number(newFieldKeys[newFieldKeys.length - 1]) + 1 || 0;
    }
    newFields[fieldId] = newField;
    if (!this.props.field) {
      this.setState({ name: "" });
    }
    batch.update(tournamentRef, { fields: newFields });
    if (this.props.field) {
      const newStartTime =
        newField[
          this.props.selectedDay === "0" ? "startTime" : this.props.selectedDay
        ];
      const newEndTime =
        this.props.selectedDay === "0"
          ? newField["endTime"]
          : newField[this.props.selectedDay + "end"];

      // Only update if start or end time changed, not if only name or sponsor changed
      if (oldStartTime !== newStartTime || oldEndTime !== newEndTime) {
        batch.set(db.collection("cacheUpdatesForField").doc(), {
          tournamentId: this.props.tournament[".key"],
          fieldId: fieldId,
          status: "pending",
          timestamp: window.firebase.firestore.FieldValue.serverTimestamp(),
        });
        if (this.props.tournament.ia) {
          batch.set(db.collection("cacheUpdatesApp").doc(), {
            tournamentId: this.props.tournament[".key"],
            status: "pending",
            timestamp: window.firebase.firestore.FieldValue.serverTimestamp(),
          });
        }
      }
    }
    batch.commit().then(() => {
      if (this.state.sponsorLogoURL && this.state.newSponsorLogo) {
        var httpsReference = window.firebase
          .app()
          .storage("gs://tournament-uploads/")
          .refFromURL(this.state.sponsorLogoURL);
        httpsReference
          .updateMetadata({
            customMetadata: {
              sponsorType: "fields",
              tournamentId: this.props.tournament[".key"],
              elementId: fieldId,
            },
          })
          .catch(function (error) {
            // Uh-oh, an error occurred!
            console.log(error.message);
          });
      }
    });
  };

  handleDeleteSponsor = () => {
    let toUpdate = { sponsorLogoURL: "", newSponsorLogo: false };
    this.setState(toUpdate);
    // let urlToDelete = this.state.sponsorLogoURL;

    // window.firebase
    //   .firestore()
    //   .collection("tournaments")
    //   .doc(this.props.tournament[".key"])
    //   .collection("sportParks")
    //   .doc(this.props.sportPark.id)
    //   .update(toUpdate);

    // var httpsReference = window.firebase
    //   .app()
    //   .storage("gs://tournament-uploads/")
    //   .refFromURL(urlToDelete);
    // httpsReference.delete().catch(function (error) {
    //   // Uh-oh, an error occurred!
    //   console.log(error.message);
    // });
  };

  getStorageRef = () => {
    return window.firebase
      .app()
      .storage("gs://tournament-uploads/")
      .ref(
        "sponsors/" + this.props.user.uid + "/" + this.props.tournament[".key"],
      );
  };

  handleUploadStart = () => {
    this.setState({
      isUploading: true,
      errorMessageSponsor: "",
    });
  };

  handleProgress = (progress) => {
    this.setState({ progress });
  };

  handleUploadError = (error) => {
    this.setState({ isUploading: false });
    let toUpdate = { errorMessageSponsor: getUploadErrorMessage(error, 1) };
    this.setState(toUpdate);
  };

  handleUploadSuccess = (filename) => {
    this.setState({ isUploading: false });
    const storageRef = this.getStorageRef();
    storageRef
      .child(filename)
      .getDownloadURL()
      .then((url) => {
        let toUpdate = { sponsorLogoURL: url, newSponsorLogo: true };
        this.setState(toUpdate);
        // window.firebase
        //   .firestore()
        //   .collection("tournaments")
        //   .doc(this.props.tournament[".key"])
        //   .collection("sportParks")
        //   .doc(this.props.sportPark.id)
        //   .update(toUpdate);
      });
  };

  render() {
    let allowedToUpload = false;
    if (
      (this.props.tournamentStatus || {}).status === 1 ||
      (this.props.tournamentStatus || {}).status === 2 ||
      (this.props.tournamentStatus || {}).status === 3 ||
      (this.props.userStatus || {}).status === 1 ||
      (this.props.userStatus || {}).status === 2 ||
      (this.props.userStatus || {}).status === 3
    ) {
      allowedToUpload = true;
    }

    return (
      <div>
        {this.props.field ? null : (
          <Button
            variant={this.props.first ? "outlined" : "outlined"}
            onClick={this.toggleDialog}
            size="small"
            disabled={this.props.tournament.scheduleLocked || false}
            style={{ marginRight: this.props.first ? 0 : 15 }}
          >
            {languages.schedule.addField}
          </Button>
        )}
        <EditFieldDialog
          name={this.state.name}
          startTime={this.state.startTime}
          endTime={this.state.endTime}
          open={this.props.field ? this.props.open : this.state.open}
          field={this.props.field}
          toggleDialog={
            this.props.field ? this.props.toggleDialog : this.toggleDialog
          }
          handleChange={this.handleChange}
          handleStartTimeChange={this.handleStartTimeChange}
          handleEndTimeChange={this.handleEndTimeChange}
          handleSubmit={this.handleSubmit}
          tournament={this.props.tournament}
          // sponsor
          sponsorName={this.state.sponsorName}
          sponsorLogoURL={this.state.sponsorLogoURL}
          sponsorStorageRef={this.getStorageRef()}
          handleDeleteSponsor={this.handleDeleteSponsor}
          handleUploadStart={this.handleUploadStart}
          handleProgress={this.handleProgress}
          handleUploadError={this.handleUploadError}
          handleUploadSuccess={this.handleUploadSuccess}
          allowedToUpload={allowedToUpload}
          handleShowSponsorChange={this.handleShowSponsorChange}
          showSponsor={this.state.showSponsor}
          toggleUpgradeDialog={this.props.toggleUpgradeDialog}
          errorMessageSponsor={this.state.errorMessageSponsor}
          isUploadingSponsor={this.state.isUploading}
        />
      </div>
    );
  }
}

export default EditFieldContainer;
